@if (banners.length > 0) {
<div class="carrossel-wrapper">
  <div class="carrossel-slide">
    <img
      [src]="'data:image/*;base64,' + banners[indiceAtual].img"
      [alt]="banners[indiceAtual].nomeImg"
      class="carrossel-imagem"
      [class.clicavel]="banners[indiceAtual].cdAcesso"
      (click)="onClickBanner(banners[indiceAtual])"
    />
  </div>

  @if (banners.length > 1) {
  <button
    class="carrossel-btn carrossel-btn-anterior"
    (click)="bannerAnterior()"
    aria-label="Banner anterior"
  >
    &#8249;
  </button>

  <button
    class="carrossel-btn carrossel-btn-proximo"
    (click)="proximoBannerManual()"
    aria-label="Próximo banner"
  >
    &#8250;
  </button>

  <div class="carrossel-indicadores">
    @for (b of banners; track b.idGeral; let i = $index) {
    <span
      class="indicador"
      [class.ativo]="i === indiceAtual"
      (click)="irParaBanner(i)"
    ></span>
    }
  </div>
  }
</div>
}
